import { sanityFetch } from './sanityFetch'
import { TypedObject } from '@portabletext/types'

type BlockChild = { text?: string }
type BlockLike = TypedObject & { children?: BlockChild[] }

/** 根据 Portable Text 估算阅读时间（中文按字符数，约 300 字/分钟） */
export function calcReadTime(body: TypedObject[] | null | undefined): number {
  if (!body?.length) return 1
  const text = body
    .filter((block): block is BlockLike => block._type === 'block')
    .map((block) => (block.children ?? []).map((c) => c.text ?? '').join(''))
    .join('')
  const minutes = Math.ceil(text.length / 300)
  return Math.max(1, minutes)
}

export interface Post {
  _id: string
  title: string
  slug: { current: string }
  publishedAt: string
  coverImage?: string
  excerpt?: string
  body?: TypedObject[]
}

export interface PostDetail extends Post {
  body: TypedObject[]
}

export const getPostList = async (
  page = 1,
  pageSize = 10
): Promise<{ posts: Post[]; total: number }> => {
  const start = (page - 1) * pageSize
  const end   = start + pageSize

  const [posts, total] = await Promise.all([
    sanityFetch<Post[]>(
      `*[_type == "post"]
       | order(publishedAt desc) [$start...$end] {
         _id, title, slug, publishedAt,
         "coverImage": coverImage.asset->url,
         "excerpt": pt::text(body[0..1]),
         body[]{
           ...,
           _type == "image"      => { "url": asset->url, alt },
           _type == "videoEmbed" => { url, caption }
         }
       }`,
      { start, end }
    ),
    sanityFetch<number>(
      `count(*[_type == "post"])`
    )
  ])

  return { posts, total }
}

export const getPostDetail = async (
  slug: string
): Promise<PostDetail | null> => {
  return sanityFetch<PostDetail>(
    `*[_type == "post" && slug.current == $slug][0] {
       _id, title, publishedAt,
       "coverImage": coverImage.asset->url,
       body[]{
         ...,
         _type == "image"      => { "url": asset->url, alt },
         _type == "videoEmbed" => { url, caption }
       }
     }`,
    { slug }
  )
}